/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { filter } from 'rxjs/operators';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { MtmaModule, MtmaModuleSetting, MtmaSettingsModules } from 'src/app/model/mtma-module';
import { MtmaUnit } from 'src/app/model/mtma-unit';
import { MODULE_AC_NTP_REGEXP, MTMA_AC_LAYOUT_MTMFA0P, MTMA_AC_LAYOUT_MTMFA1P, MTMA_AC_LAYOUT_MTMFA2P } from 'src/app/conf/mtma-module';
import { TranslateService } from '@ngx-translate/core';
import { TIMEZONES } from 'src/app/conf/timezones';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { selecMtmaSettingsModules, selectMtmaActiveTask, selectMtmaEditModule, selectMtmaUnits } from 'src/app/store/device/device.selector';
import { MtmaTask } from 'src/app/model/mtma-task';
import { StandardDynamicComponent, StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { MtmaGenericEntryInfoDialogComponent } from '../mtma-generic-entry-info-dialog/mtma-generic-entry-info.dialog.component';

@Component({
	selector: 'app-mtma-manage-module-ac',
	templateUrl: './mtma-manage-module-ac.component.html',
	animations: [],
})

export class MtmaManageModuleAcComponent implements OnInit, OnDestroy {
	mtmaSettingsModules$: Observable<MtmaSettingsModules[] | undefined>;
	mtmaSettingsModulesSub: Subscription | undefined;
	mtmaActiveTask$: Observable<MtmaTask | undefined>;
	mtmaActiveTaskSub: Subscription | undefined;
	mtmaUnits$: Observable<MtmaUnit[] | undefined>;
	mtmaUnitsSub: Subscription | undefined;
	editModule$: Observable<boolean | undefined>;
	editModuleSub: Subscription | undefined;

	moduleForm: FormGroup;
	listUnit: MtmaUnit[];
	filteredUnit1: MtmaUnit[];
	filteredUnit2: MtmaUnit[];
	layoutList: any;
	upUnit: MtmaUnit;

	module: MtmaModule;

	mtmacConfig: MtmaModuleSetting[];
	timezones = TIMEZONES;

	filterCtrlButton1 = new FormControl('');
	filteredUnitsButton1: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	filterCtrlButton2 = new FormControl('');
	filteredUnitsButton2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

	isActiveTask = false;

	saving = false;

	ref: DynamicDialogRef | undefined;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private formBuilder: FormBuilder,
		private translate: TranslateService,
		public config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		public dialogService: DialogService,
	) {
		if (this.config.data !== undefined && this.config.data.module !== undefined) {
			this.module = this.config.data.module;
			if (this.module !== undefined && this.module.Config !== undefined) {
				if (this.module.Config.EnableLogAccess === undefined || this.module.Config.EnableLogAccess === null) {
					this.module.Config.EnableLogAccess = 0;
				}
				if (this.module.Config.EnableLogCall === undefined || this.module.Config.EnableLogCall === null) {
					this.module.Config.EnableLogCall = 0;
				}
				if (this.module.Config.EnableLogSystem === undefined || this.module.Config.EnableLogSystem === null) {
					this.module.Config.EnableLogSystem = 0;
				}
				if (this.module.Config.In1Notify === undefined || this.module.Config.In1Notify === null) {
					this.module.Config.In1Notify = 0;
				}
			}
		}
		this.initSelectors();
	}

	initSelectors(): void {
		this.mtmaSettingsModules$ = this.store.select(selecMtmaSettingsModules);
		this.mtmaActiveTask$ = this.store.select(selectMtmaActiveTask);
		this.mtmaUnits$ = this.store.select(selectMtmaUnits);
		this.editModule$ = this.store.select(selectMtmaEditModule);
	}

	ngOnInit(): void {
		this.upUnit = new MtmaUnit();
		this.upUnit.Name = this.translate.instant('BUTTON_NOT_SELECT');
		this.upUnit.ObjId = '000000000000000000000000';
		this.layoutList = [{ label: 'assets/images/mtma/mtm_black_0_0.svg', value: '0' },
		{ label: 'assets/images/mtma/mtm_black_0_1.svg', value: '1' },
		{ label: 'assets/images/mtma/mtm_black_0_2.svg', value: '2' }];

		this.mtmaSettingsModulesSub = this.mtmaSettingsModules$.subscribe(list => {
			const module = list.filter(item => item.ModuleType === 0)[0];
			this.mtmacConfig = module.ListSettings.filter(con => con.Name !== 'EnableLogSystem' && con.Name !== 'In1Notify'); // Not visible Now
		});
		//this.buildForm();
		this.dispatchGetUnits();
		this.mtmaUnitsSub = this.mtmaUnits$.pipe(
			filter((units) => !!units)
		).subscribe(units => {
			this.listUnit = units.slice();
			this.listUnit.unshift(this.upUnit);
			this.buildForm();
		});

		this.mtmaActiveTaskSub = this.mtmaActiveTask$.subscribe(mtmaActiveTask => {
			if (mtmaActiveTask.Id !== '') {
				this.isActiveTask = true;
			} else {
				this.isActiveTask = false;
			}
		});
		this.editModuleSub = this.editModule$.subscribe(editModule => {
			if (editModule) {
				this.closeDialog();
			}
		});

		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	buildForm(): void {
		let button1 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[0]);
		let button2 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[1]);
		if (button1 === undefined) {
			button1 = this.upUnit;
		}
		if (button2 === undefined) {
			button2 = this.upUnit;
		}
		const formGroup = {
			Name: [this.module.Name, [Validators.required, Validators.maxLength(48)]],
			Layout: [this.module.Config.Layout.toString()],
			Button1: [button1],
			Button2: [button2],
		};
		for (const setting of this.mtmacConfig) {
			if (setting.Type === 'bits') {
				let listComp = [];
				let value = this.module.Config[setting.Name];
				for (const val of setting.Values.reverse()) {
					if (value !== 0 && value / (2 ** val.Value) >= 1) {
						listComp.push(val.Value);
						value = value - (2 ** val.Value);
					}
				}
				listComp = listComp.reverse();
				formGroup[setting.Name] = [listComp];
			} else if (setting.Name === 'NtpServer') {
				formGroup[setting.Name] = [this.module.Config[setting.Name], [Validators.required, Validators.pattern(MODULE_AC_NTP_REGEXP)]];
			} else if (setting.Type === 'intset' || setting.Type === 'bool') {
				formGroup[setting.Name] = [setting.Values.find(set => set.Value === this.module.Config[setting.Name])];
			} else {
				formGroup[setting.Name] = [this.module.Config[setting.Name]];
			}
		}
		this.moduleForm = this.formBuilder.group(formGroup);
		this.onChangeLayout();
	}

	ngOnDestroy(): void {
		this.mtmaSettingsModulesSub?.unsubscribe();
		this.mtmaActiveTaskSub?.unsubscribe();
		this.mtmaUnitsSub?.unsubscribe();
		this.editModuleSub?.unsubscribe();
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.moduleForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.moduleForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		this.saving = true;
		this.module = {
			...this.module,
			Name: this.f.Name.value,
		};
		this.module.Config.Layout = Number(this.f.Layout.value);
		this.module.Config.Buttons = [this.f.Button1.value.ObjId, this.f.Button2.value.ObjId];
		for (const setting of this.mtmacConfig) {
			if (setting.Type === 'bits') {
				let value = 0;
				for (const val of this.moduleForm.controls[setting.Name].value) {
					value = value + (2 ** val);
				}
				this.module.Config[setting.Name] = value;
			} else if (setting.Type === 'intset' || setting.Type === 'bool') {
				this.module.Config[setting.Name] = this.moduleForm.controls[setting.Name].value.Value;
			}
			else {
				this.module.Config[setting.Name] = this.moduleForm.controls[setting.Name].value;
			}
		}
		this.store.dispatch(DeviceActions.editMtmaModule({ module: this.module }));
	}

	isButtonDisable(button: number): boolean {
		if (Number(this.f.Layout.value) === MTMA_AC_LAYOUT_MTMFA2P) { //always active
			return false;
		} else if (Number(this.f.Layout.value) === MTMA_AC_LAYOUT_MTMFA1P && button === 2) { //active only button 2
			return false;
		}
		return true;
	}

	dispatchGetUnits(): void {
		this.store.dispatch(DeviceActions.getMtmaUnits({}));
	}


	onChangeLayout(): void {
		let button1 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[0]);
		let button2 = this.listUnit.find(un => un.ObjId === this.module.Config.Buttons[1]);
		if (button1 === undefined) {
			button1 = this.upUnit;
		}
		if (button2 === undefined) {
			button2 = this.upUnit;
		}
		switch (Number(this.f.Layout.value)) {
			case MTMA_AC_LAYOUT_MTMFA1P:
				this.f.Button1.setValue(this.listUnit[0]);
				this.f.Button2.setValue(button2);
				this.f.Button1.disable();
				this.f.Button2.enable();
				break;
			case MTMA_AC_LAYOUT_MTMFA0P:
				this.f.Button1.setValue(this.listUnit[0]);
				this.f.Button2.setValue(this.listUnit[0]);
				this.f.Button1.disable();
				this.f.Button2.disable();
				break;
			default:
				this.f.Button1.setValue(button1);
				this.f.Button2.setValue(button2);
				this.f.Button1.enable();
				this.f.Button2.enable();
		}
	}

	//-----SLIDER

	getValueFloat(value: number): number {
		return parseFloat(value.toFixed(1));
	}

	getValueString(value: number, scale: number): string {
		if (Math.floor(scale) === 1) {
			return value.toFixed(0);
		}
		return value.toFixed(1);
	}

	scaledValueFloat(value: number, scale: number): number {
		return this.getValueFloat(value * scale);
	}

	scaledValueString(value: number, scale: number): string {
		return this.getValueString(value * scale, scale).replace(".", ",");
	}

	formattedSliderMin(setting: MtmaModuleSetting): string {
		return this.scaledValueString(setting.Min, 1);
	}

	formattedSliderMax(setting: MtmaModuleSetting): string {
		return this.scaledValueString(setting.Max, 1);
	}

	isSliderMin(setting: MtmaModuleSetting): boolean {
		return this.moduleForm.controls[setting.Name].value <= setting.Min;
	}

	isSliderMax(setting: MtmaModuleSetting): boolean {
		return this.moduleForm.controls[setting.Name].value >= setting.Max;
	}

	onChangeInputSlider(setting: MtmaModuleSetting) {
		this.f[setting.Name].setValue(this.f[setting.Name].value);
	}

	onChangeSlider(setting: MtmaModuleSetting) {
		this.f[setting.Name].setValue(this.f[setting.Name].value);
	}

	setSliderValue(setting: MtmaModuleSetting, value: number): boolean {
		let newValue = this.f[setting.Name].value + value * setting.StepSize;
		newValue = this.getValueFloat(newValue);
		if (newValue < setting.Min) {
			return false;
		}
		if (newValue > setting.Max) {
			return false;
		}
		// const oldValue = this.f[setting.Id].value;
		newValue = this.scaledValueFloat(newValue, 1);
		this.f[setting.Name].setValue(newValue);
		this.f[setting.Name].markAsDirty();
		return true;
	}
	//-----SLIDER

	infoDialogGenericEntry() {
		this.ref = this.dialogService.open(MtmaGenericEntryInfoDialogComponent, {
			header: this.translate.instant('MTMA_CONF_{Information}') + ': ' + this.translate.instant('MTMA_CONF_In1Func'),
			contentStyle: { overflow: 'auto' },
			data: {}
		})
	}

	getTranslate(name: string, forceTraslate: boolean): string {
		if (name.includes('{') || forceTraslate) {
			return this.translate.instant('MTMA_CONF_' + name);
		} else {
			return name;
		}
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	get f(): any {
		return this.moduleForm.controls;
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6Responsive(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	justifyMessagesNewValidator(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaManageModuleAcComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	dynamicAutocomplete(): string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}

	dynamicBorderLabelMobile(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaManageModuleAcComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

}
